import React, { useEffect } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ShippingPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <Wrapper>
      <Header data-aos="fade-down">
        <h1>Shipping & Delivery Policy</h1>
        <p>Effective Date: July 9, 2025</p>
      </Header>

      <Section data-aos="fade-up">
        <h2>Introduction</h2>
        <p>
          At Totomart, a digital-first platform operated by Ligiotech Solutions Pvt Ltd, most of our services
          are delivered online. However, in specific cases where physical delivery is required (e.g., hard copies
          of rental agreements or legal documents), the following shipping and delivery policy will apply.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Digital Deliverables</h2>
        <p>
          All standard services, including property listings, online rent payments, verification reports, and digital
          rental agreements, are delivered electronically via our platform or email. You can access these services
          through your Totomart account dashboard.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Physical Deliverables</h2>
        <p>
          If you opt for physical copies of rent agreements or notarized documents, shipping is available to serviceable
          PIN codes across India.
        </p>
        <ul>
          <li><strong>Courier Partner:</strong> DTDC, Bluedart, or India Post (as applicable)</li>
          <li><strong>Processing Time:</strong> 2–3 working days after verification</li>
          <li><strong>Estimated Delivery Time:</strong> 5–7 working days (depending on location)</li>
          <li><strong>Shipping Charges:</strong> ₹99 to ₹299 based on distance and urgency</li>
        </ul>
      </Section>

      <Section data-aos="fade-up">
        <h2>Delivery Tracking</h2>
        <p>
          Once your order is dispatched, a tracking ID and courier link will be shared via email/SMS. You can also
          track delivery status from your account dashboard under “Orders.”
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Service Availability</h2>
        <p>
          Delivery services are available across India, subject to courier partner reach. Remote or unserviceable
          PIN codes may result in extended timelines or digital-only delivery.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Failed Deliveries</h2>
        <p>
          If delivery fails due to incorrect address, unreachable phone number, or repeated non-availability, you may
          need to pay reshipping charges. Refunds will not be issued for failed deliveries unless the error is on our side.
        </p>
      </Section>

      <Section data-aos="fade-up">
        <h2>Contact & Support</h2>
        <p>
          For shipping-related queries, please contact:
        </p>
        <p>
          Totomart Shipping Desk<br />
          Email: support@totomart.in<br />
          Phone: +91-7373339225<br />
          Address: No. 71, Appar Street, Thiruvalleswarar Nagar, Thirumangalam, Anna Nagar, Chennai – 600040
        </p>
      </Section>

      <FooterNote data-aos="fade-in">
        <p>Totomart – Where digital delivery meets peace of mind.</p>
      </FooterNote>
    </Wrapper>
  );
};

export default ShippingPolicy;

// Styled-components
const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 3rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
  color: #333;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    font-size: 2.4rem;
    color: #e53935;
  }

  p {
    color: #666;
    font-size: 1rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2rem;

  h2 {
    color: #b71c1c;
    font-size: 1.5rem;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.7;
    color: #444;
  }

  ul {
    margin: 1rem 0;
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.5rem;
      list-style-type: disc;
      font-size: 1rem;
      color: #444;
    }
  }
`;

const FooterNote = styled.div`
  text-align: center;
  color: #777;
  font-size: 0.95rem;
  margin-top: 3rem;
  border-top: 1px solid #eee;
  padding-top: 1.5rem;
`;
